export const EMAIL_CAMPAIGN_LIMITS = {
  MAX_RECIPIENTS: 5000,
} as const;

export const EMAIL_CAMPAIGN_DEFAULTS = {
  PAGE_SIZE: 1000,
  MAX_QUERY_RESULTS: 50000,
} as const;
